import NudgesModalContainer from "../NudgesModalContainer";
import { useEffect } from "react";

import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useLoader } from "@/app/hooks/useLoader";
import SkeletonType2 from "../../Skeletons/Type2";
import { INudgesPayloadProps, useNudgesAlertAPI } from "@/app/hooks/api_hooks/nudges/useNudgesAlertAPI";
import { IClickLogBody, useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";
import { BLUE7_BORIVALI_CLINIC_ID } from "@/constants";
export interface INudgesContainerProps {
  source: string;
  alert_category_list: string[];
  customer_id?: string;
  pet_Id?: string;
  cart_id?: string;
  ermid?: string;
  service_id?: string;
  sub_service_id?: string;
  staff_id?: string;
  slot_start_time?: string;
  slot_end_time?: string;
  clinic_id?: string;
  journey_point?: string;
  role_id?: string;
  booking_list?: string;
  setNudgeNotPresent?: (value: boolean) => void;
  addMembershipAndFoodInCart?: (value: any, s: any, l?: any) => void;
  handelAddFoodAndMedicine?: (value: any) => void;
  handelCheckoutFunction?: (el: boolean, cta: string) => void;
  setCheckoutNudge?: (value: boolean) => void;
  setIsNotPreferedDoctorNudgeOpen?: (value: boolean, cl: any) => void;
  checkoutNudge?: boolean;
  setNudgeData?: (val: any) => void;
}

const NudgesContainer: React.FC<INudgesContainerProps> = ({
  source,
  alert_category_list,
  customer_id,
  pet_Id,
  ermid,
  cart_id,
  service_id,
  sub_service_id,
  staff_id,
  slot_start_time,
  slot_end_time,
  clinic_id,
  journey_point,
  role_id,
  booking_list,
  setNudgeNotPresent,
  addMembershipAndFoodInCart,
  handelAddFoodAndMedicine,
  handelCheckoutFunction,
  setCheckoutNudge,
  checkoutNudge,
  setIsNotPreferedDoctorNudgeOpen,
  setNudgeData
}) => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerId, petId } = routeState.state as ICustomerProfileState;

  const userRole = useAppSelector((state) => state?.auth?.userPermissions ?? state?.auth?.userRole);
  const resolvedRoleId = role_id ?? userRole?.role_id;

  const userLogInfo = useAppSelector((state) => state.auth?.user?.email);
  const { mappedClinicId } = useAppSelector((state) => state.root.UIStates);

  // Blue7Vets, Borivali: upsell nudges are disabled for this clinic.
  const activeClinicId = clinic_id ? clinic_id : mappedClinicId;
  const isNudgeDisabledForClinic = activeClinicId === BLUE7_BORIVALI_CLINIC_ID;

  const { execute: fetchNudges, nudges } = useNudgesAlertAPI();
  const { execute: logAPI } = useClickLogAPI();



  const user = useAppSelector((state) => state?.auth?.userRole)



  useEffect(() => {
    if (isNudgeDisabledForClinic) {
      // Skip the nudge fetch for disabled clinics and behave as "no nudge
      // present" so dependent flows (PWL / cart checkout) proceed unblocked.
      checkoutNudge && handelCheckoutFunction(false, "CT");
      source === "PWL" && setNudgeNotPresent && setNudgeNotPresent(true);
      source === "booking_journey" && setIsNotPreferedDoctorNudgeOpen && setIsNotPreferedDoctorNudgeOpen(false, null);
      return;
    }
    if (resolvedRoleId && (customerId || customer_id) && (petId || pet_Id)) {
      const constructedBody: INudgesPayloadProps = {
        customer_id: source === "PWL" ? customer_id : customerId,
        pet_id: source === "PWL" || source === "Cart" ? pet_Id : petId,
        journey_point: journey_point ? journey_point : source?.toLowerCase(),
        alert_category_list: alert_category_list,
        service_id: service_id ? service_id : undefined,
        sub_service_id: sub_service_id ? sub_service_id : undefined,
        role_id: resolvedRoleId,
        clinic_id: clinic_id ? clinic_id : mappedClinicId,
        booking_list: booking_list ? booking_list : undefined,
        emr_id: ermid ? ermid : undefined,
        cart_id: cart_id ? cart_id : undefined,
        doctor_id: staff_id ? staff_id : undefined,
        slot_start_time: slot_start_time ? slot_start_time : undefined,
        slot_end_time: slot_end_time ? slot_end_time : undefined,
      };
      fetchNudges(constructedBody).then(({ status, message }) => {
        const isMedicatedBathNudge = message?.alert_category_list?.includes("Medicated Bath Add on check");
        if (status === false || isMedicatedBathNudge) {
          checkoutNudge && handelCheckoutFunction(false, "CT");
          source === "PWL" && setNudgeNotPresent(true);
          source === "booking_journey" && setIsNotPreferedDoctorNudgeOpen(false, null);
        } else {

          const logBody: IClickLogBody = {
            event_type: "NUDGE_OPENED",
            client_id: source === "PWL" ? customer_id : customerId,
            pet_id: source === "PWL" ? pet_Id : petId,
            vms_user_id: userLogInfo,
            scr_id: source?.toLowerCase(),
            timestamp: Date.now(),
            nudge_type: message?.alert_category_list?.length > 0 && message?.alert_category_list[0],
            nudge_name: message?.name,
          };
          logAPI(logBody);
          source === "PWL" && setNudgeNotPresent(false);

          checkoutNudge && message?.length === 0 && handelCheckoutFunction(false, "CT");
          source === "EMR" && setNudgeData(message)
          if (source === "booking_journey" && message?.length === 0) {
            setIsNotPreferedDoctorNudgeOpen(false, null);
          } else {
            setIsNotPreferedDoctorNudgeOpen(true, null);
          }
        }
      });
    }
  }, [source, resolvedRoleId, customerId, petId, customer_id, pet_Id, isNudgeDisabledForClinic]);

  useEffect(() => {
    if (nudges === null && source === "PWL") {
      setNudgeNotPresent(true);
    }
    // if (nudges === null && source === "booking_journey") {
    //   setIsNotPreferedDoctorNudgeOpen(false);
    // }
  }, [nudges]);

  const isNudgeLoading = useLoader("isNudgeLoadingInpogress");

  if (isNudgeDisabledForClinic) return null;

  return isNudgeLoading && source === "PWL" ? (
    <SkeletonType2 />
  ) : (
    <div>
      <NudgesModalContainer
        nudge={nudges}
        source={source}
        customer_id={source === "PWL" ? customer_id : customerId}
        addMembershipAndFoodInCart={addMembershipAndFoodInCart}
        handelAddFoodAndMedicine={handelAddFoodAndMedicine}
        handelCheckoutFunction={handelCheckoutFunction}
        alert_category_list={alert_category_list}
        pet_Id={pet_Id}
        journey_point={journey_point}
        setCheckoutNudge={setCheckoutNudge}
        setIsNotPreferedDoctorNudgeOpen={setIsNotPreferedDoctorNudgeOpen}
      />
    </div>
  );
};

export default NudgesContainer;
